module.exports = __webpack_public_path__ + "static/media/directions.0a167a4c.svg";